import { render } from "./SpamFilesPage.vue?vue&type=template&id=4f1c0f5e&ts=true"
import script from "./SpamFilesPage.vue?vue&type=script&lang=ts"
export * from "./SpamFilesPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__